<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table
      :data="users"
      v-loading="listLoading"
      row-key="Id"
      border
      lazy
      :load="load"
      :tree-props="{ children: 'Children', hasChildren: 'hasChildren' }"
      style="width: 100%"
      ref="table"
      @select="dialogCheck"
      @row-click="selectCurrentRow"
      class="custom-tbl"
    >
      <el-table-column label="课程名称" width="210">
        <template slot-scope="scope">
          {{ scope.row.Subject }}
        </template>
      </el-table-column>
      <el-table-column
        prop="Name"
        label="评论人"
        width
      ></el-table-column>
      <el-table-column
        prop="Content"
        label="评论内容"
        width
      ></el-table-column>

      <el-table-column
        prop="CreateTime"
        label="评论日期"
        :formatter="formatDateTime"
        width
        sortable
      ></el-table-column>
      <el-table-column
        prop="Status"
        label="状态"
        :formatter="formatStatus"
        width
        sortable
      ></el-table-column>     
      <el-table-column label="操作">
        <template scope="scope">
          <el-link
            type="primary"
            :disabled = "scope.row.Status =='1' ? false : true"
            :style = "scope.row.Status =='1' ?'':{color : '#aba6a5 !important' }"
            @click="handleEdit(scope.row)"
          >
            回复
          </el-link> | 
          <el-link
            type="primary"
            :disabled = "scope.row.Status =='1' ? true : false"
            :style = "scope.row.Status =='1' ?{color : '#aba6a5 !important' }:''"
            @click="saveUptEvaluation(scope.row.Id,1)">
            通过
          </el-link> |  
          <el-link
            @click="saveUptEvaluation(scope.row.Id,2)">
            驳回
          </el-link>     
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>
    <el-dialog
      :title="dialog_title"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :before-close="editForm_close"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="180px"
        :rules="editFormRules"
        ref="editForm"
      >
      <el-row>
          <el-col :span="24">
            <el-form-item label="回复内容" prop="Content">
              <el-input
                :disabled="DETAIS_IF"
                v-model="editForm.Content"
                auto-complete="off"
                placeholder="请输入回复内容"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editForm_close">取消</el-button>
        <el-button
          v-if="!DETAIS_IF"
          type="primary"
          @click.native="editSubmit('editForm')"
          :loading="editLoading"
        >
          确认
        </el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import util from "../../../util/date";
  import {
    EvaluationList,
    EvaluationPost,
    UptEvaluation,
  } from "../../api/api";
  import { getButtonList } from "../../promissionRouter";
  import Toolbar from "../../components/Toolbar";

  export default {
    components: { Toolbar },
    data() {
      return {
        buttonList: [],
        currentRow: null,
        options: [],
        filters: {
          Name: "",
        },
        users: [],
        modules: [], //接口api列表
        statusList: [
          { Name: "激活", value: true },
          { Name: "禁用", value: false },
        ],
        total: 0,
        page: 1,
        listLoading: false,
        sels: [], //列表选中列
        dialog_title: "",
        DETAIS_IF: true,
        addDialogFormVisible: false,
        editFormVisible: false, //编辑界面是否显示
        editLoading: false,
        editFormRules: {
          Content: [
            { required: true, message: "请输入回复内容", trigger: "blur" },
          ],
        },
        //编辑界面数据
        editForm: {
          Id: "",
          Content: "",
        },
        ReplyRow: {},
      };
    },
    methods: {
      dialogCheck(selection, row) {
        this.currentRow = null;
        this.$refs.table.clearSelection();
        if (selection.length === 0) {
          return;
        }
        if (row) {
          this.selectCurrentRow(row);
        }
      },
      selectCurrentRow(val) {
        if (val) {
          this.currentRow = val;
          this.$refs.table.clearSelection();
          this.$refs.table.toggleRowSelection(val, true);
        }
      },
      async editSubmit(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            let data;
            if (this.dialog_title == "回复") {
              this.editForm.Id = this.ReplyRow.Id;
              console.log(this.ReplyRow.Id)
              console.log(this.editForm.Id)
              data = await EvaluationPost(this.editForm);
            }
            if (data.data.success) {
              this.editFormVisible = false;
              this.$message({
                message: data.data.msg,
                type: "success",
              });
              this.getModules_search();
              this.editForm = {};
            }
            else
            {
              this.editFormVisible = false;
              this.$message({
                message: data.data.msg,
                type: "error",
              });
            }
          } else {
            return false;
          }
        });
      },
    editForm_close() {
      this.editFormVisible = false;
      this.editForm = {};
    },
    async details_EvaluationGet(ids) {
      // console.log(ids)
      const { data } = await EvaluationGet({
        id: ids,
      });
      this.editForm = data.response;
    },
    // 查看
    async handleOpen(ids) {
      this.details_EvaluationGet(ids);
      this.DETAIS_IF = true;
      this.READ = true;
      this.READ_IF = true;
      this.editFormVisible = true;
      this.dialog_title = "查看";
      this.$nextTick(() => {
        this.$refs.editForm.resetFields();
      });
    },
    async handleEdit(row) {
      this.ReplyRow = row;
      this.editFormVisible = true;
      this.dialog_title = "回复";
      this.DETAIS_IF = false;     
      // this.$nextTick(() => {
      //   this.$refs.editForm.resetFields();
      // });
    },
      callFunction(item) {
        this.filters = {
          name: item.search,
        };
        this[item.Func].apply(this, item);
      },
      formatStatus: function (row, column) {
      let data = row[column.property]
      if (data == 0) {
        return "待审核"
      }else if (data == 1){
        return "审核通过";
      }else if (data == 2){
        return "驳回";
      }
      else {
        return null
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getModules();
    },
    getModules_search() {
      this.page = 1;
      this.getModules();
    },
      //性别显示转换
      formatEnabled: function (row, column) {
        return row.Enabled ? "正常" : "未知";
      },
      formatCreateTime: function (row, column) {
        return !row.CreateTime || row.CreateTime == ""
          ? ""
          : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
      },
      handleCurrentChange(val) {
        this.page = val;
        this.getModules();
      },
      load(tree, treeNode, resolve) {
        let para = {
          page: this.page,
          f: tree.Id,
          key: this.filters.Name,
        };
        EvaluationList(para).then((res) => {
          resolve(res.data.response.data);
          console.log(res.data.response.data)
        });
      },
      //获取用户列表
      getModules() {
        let para = {
          page: this.page,
          key: this.filters.name,
        };
        this.listLoading = true;
        EvaluationList(para).then((res) => {
          this.users = res.data.response.data;
          this.listLoading = false;
          // console.log(res.data.response.data)
        });
      },
      //日期显示转换
      formatDateTime: function (row, column) {
      let data = row[column.property]
      if (data == null) {
        return null
      } else {
        return util.formatDate.format(new Date(data), "yyyy-MM-dd");
      }
    },
      //审核,阻止，驳回保存
      saveUptEvaluation(id,status) {
      var msg='';
      console.log(id);
      console.log(status)
      if(status==1)
      {
        msg="确认通过审核吗?"
      }else if(status==2)
      {
        msg="确认阻止吗?"
      }
      this.$confirm(msg, "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          UptEvaluation({
            id: id,
            status:status
          }).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getModules_search();
          });
        })
        .catch(() => {});
    },
      //删除
      handleDel() {
        let row = this.currentRow;
        if (!row) {
          this.$message({
            message: "请选择要删除的一行数据！",
            type: "error",
          });

          return;
        }
        this.$confirm("确认删除该记录吗?", "提示", {
          type: "warning",
        })
          .then(() => {
            this.listLoading = true;
            //NProgress.start();
            let para = { id: row.Id };
            removePermission(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.listLoading = false;
                return;
              }
              this.listLoading = false;
              //NProgress.done();
              if (res.data.success) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }

              this.getModules();
            });
          })
          .catch(() => {});
      },    
     
    },
    mounted() {
      this.getModules();

      // getModuleListPage({ page: -1 }).then((res) => {
      //   this.modules = res.data.response.data;
      // });

      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      this.buttonList = getButtonList(this.$route.path, routers);
    },
  };
</script>

<style scoped>
  .custom-tbl /deep/ .has-gutter .el-checkbox {
    display: none;
  }
</style>
<style>
  .el-button--primary {
    background-color: #409eff !important;
    border-color: #409eff !important;
  }
  /* 
  .el-link.el-link--primary:hover {
    color: #c0826e !important;
  } */

  .el-link.el-link {
    color: #409eff !important;
  }
  .el-link.is-underline:hover:after {
    border-bottom: 1px solid #409eff !important;
  }
  .el-link.el-link--default:after,
  .el-link.el-link--primary.is-underline:hover:after,
  .el-link.el-link--primary:after {
    border-color: #409eff !important;
  }
  .el-pager li.active {
    color: #409eff !important;
  }
</style>
